import {FC, useState} from 'react'
import {useQuery} from 'react-query'
import {Get} from '../../../../setup'
import {Contact, initialContact, ContactsResponse, ContactsContext} from '../../../@types'

const CONTACTS = process.env.REACT_APP_MAILING_SUBSCRIBERS || 'v2/subscribers'

const ContactsProvider: FC = ({children}) => {

  const [data, setData] = useState<Contact[]>([initialContact])
  const [reloadKey, setReloadKey] = useState<number>(0)

  const triggerReload = () => setReloadKey(prevState => prevState + 1)

  useQuery(
    [`CONTACTS`, reloadKey],
    () => Get<ContactsResponse>({endpoint: CONTACTS}),
    {
      onSuccess: ({data}) => {
        setData(data)
      },
    },
  )

  return (
    <ContactsContext.Provider value={{data, reloadKey, triggerReload}}>
      {children}
    </ContactsContext.Provider>
  )
}

export {ContactsProvider}